import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import InputField from "../../components/form/InputField";
import SelectField from "../../components/form/SelectField";
import axios from "../../api/axios";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import {
  getCountryCommunities,
  unsetCommunity,
} from "../../features/communitiesSlice";
import { zodResolver } from "@hookform/resolvers/zod";
import { editUserSchema } from "../../schemas";
import { findRoleById } from "../../util";
import { editUser, setSelectedUser } from "../../features/usersSlice";
import { closeModal } from "../../features/modalSLice";
import Loading from "../../components/loading/Loading";
import { useNotification } from "../../components/notification/NotificationContainer";

const EditUser = ({ id }) => {
  const dispatch = useDispatch();
  const communities = useSelector((state) => state.communities.data);

  const province_id = useSelector((state) => state.user.userInfo.province_id);
  const addUserLoad = useSelector((state) => state.users.load.editUser);
  const mainUser = useSelector((state) => state.user.userInfo);
  const user = useSelector((state) => state.users.selected);
  const [roles, setRoles] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const addNotification = useNotification();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      other_names: "",
      role_id: "",
      organization_id: "",
      department_id: "",
      community_id: "",
    },
    resolver: zodResolver(editUserSchema),
  });

  const watchAllFields = watch();

  //Get register organization, and roles
  const getRegister = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get("/register", {
        params: { id: province_id },
      });

      setRoles(
        response.data.roles.filter((item) =>
          mainUser.role === "Super Administrator"
            ? province_id
            : item.name.toLowerCase() !== "super administrator" && province_id
        )
      );
      setOrganizations(response.data.organizations);
      setDepartments(response.data.departments);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response) {
        addNotification(error.response.data.message, "error");
      }
      addNotification(error.message, "warning");
      dispatch(closeModal());
    }
  }, [setRoles]);

  //When the form is submitted add the user
  const onSubmit = async (data, e) => {
    e.preventDefault();
    let res;
    try {
      if (
        (findRoleById(roles, data.role_id, "community cordinator") &&
          data.community_id) ||
        !findRoleById(roles, data.role_id, "community cordinator")
      ) {
        //Submit data
        res = await dispatch(editUser({ id, reqData: data }));
        if (editUser.fulfilled.match(res)) {
          dispatch(setSelectedUser(res.payload || {}));
          dispatch(closeModal());
          dispatch(unsetCommunity());
          addNotification("User updated successfully", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        addNotification("There is no Community id", "warning");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  //Get Role Values
  useEffect(() => {
    getRegister();
  }, []);

  useEffect(() => {
    if (user.id) {
      dispatch(getCountryCommunities(user.organization_id));
    }
  }, [user]);

  useEffect(() => {
    if (watchAllFields.organization_id) {
      setValue("community_id", "");
      dispatch(getCountryCommunities(watchAllFields.organization_id));
    } else {
      setValue("community_id", "");
      dispatch(unsetCommunity());
    }
  }, [watchAllFields.organization_id]);

  useEffect(() => {
    if (user.id && communities) {
      reset({
        first_name: user.first_name,
        last_name: user.last_name,
        other_names: user.other_names || "",
        department_id: user.department_id,
        organization_id: user.organization_id,
        community_id: user.communities?.[0]?.id || "",
        role_id: user.roles?.[0]?.id || "",
      });
    }
  }, [user, communities, roles, departments]);

  // if (loading) {
  //   return <Loading />;
  // }
  return (
    <div className="overflow-auto min-w-72 sm:min-w-[40rem] w-full">
      <h3 className="text-center m-7">Edit User</h3>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <InputField
            register={register}
            errors={errors.first_name}
            label="First Name"
            name="first_name"
            type="text"
          />
          <InputField
            register={register}
            errors={errors.last_name}
            label="Last Name"
            name="last_name"
            type="text"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <InputField
            register={register}
            errors={errors.other_names}
            label="Other Names"
            name="other_names"
            placeholder="Kojo"
            type="text"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <SelectField
            register={register}
            errors={errors.organization_id}
            data={[{ id: "", name: "-- Select Location" }, ...organizations]}
            name="organization_id"
            label="Country or Station"
          />
          <SelectField
            register={register}
            errors={errors.role_id}
            data={[{ id: "", name: "-- Select Role" }, ...roles]}
            name="role_id"
            label="Role"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <SelectField
            register={register}
            data={[{ id: "", name: "--Select Department" }, ...departments]}
            errors={errors.department_id || ""}
            name="department_id"
            label="Department"
          />
          <SelectField
            register={register}
            errors={errors.community_id}
            data={[{ id: "", name: "--Select Community" }, ...communities]}
            name="community_id"
            label="Community"
          />
        </div>
        {/* <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <InputField
            register={register}
            errors={errors.email}
            label="Email"
            name="email"
            placeholder="david@examplie.com"
            type="email"
            autoComplete="false"
          />

          <div className="flex-1"></div>
        </div> */}

        <InputField
          type="hidden"
          register={register}
          name="province_id"
          defaultValue={user.province_id || ""}
        />
        <ResourseButtons loading={addUserLoad} submitText="Save" />
      </form>
    </div>
  );
};

export default EditUser;
